import { ROUTE_TALK_TO_US } from '../constants';
import { trackHamburgerContactUsClick } from './pulseHamburgerMenuClick';

/** Fire analytics for known navbar nav links without touching link UI logic. */
export const maybeTrackNavbarNavLinkClick = (
  link: string,
  page_path?: string
): void => {
  if (link === ROUTE_TALK_TO_US) {
    trackHamburgerContactUsClick(page_path);
  }
};
